import { DownloadedFile } from '@/core';
import { browserDownload, openInNewWindow } from './browserUtils';

export const browserFileDownload = (file: DownloadedFile) => {
  browserDownload(file.fileName, file.blob);
};

export const openFileInNewWindow = (file: DownloadedFile) => {
  const url = window.URL.createObjectURL(file.blob);
  openInNewWindow(url);
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

export const openPdfWithPageInNewWindow = (file: DownloadedFile, page: number) => {
  const url = window.URL.createObjectURL(file.blob);
  openInNewWindow(url + `#page=${page}`);
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
